import { CRYPTO, KOREA, US } from "./constant/ITME_INFO";
import { AFTER_MARKET_FIN_MIN_DELAY, CLOSE, CLOSE_ENG, DAY_DELAY, DAY_DELAY_ENG, FIVEMIN_DELAY, FIVEMIN_DELAY_ENG } from "./constant/STATUS";
import { getCurrentKSTDate } from "./useFormattedDate";

const priceUpdateStatus = async (router: any, cat: string | "", isHoliday: boolean, detailData: any) => {
    const close = router.locale === "ko" ? CLOSE : CLOSE_ENG;
    const fiveMinDelay = router.locale === "ko" ? FIVEMIN_DELAY : FIVEMIN_DELAY_ENG;
    const dayDelay = router.locale === "ko" ? DAY_DELAY : DAY_DELAY_ENG;
    const nothing = "";
    const afterMarketFinMinDelay = AFTER_MARKET_FIN_MIN_DELAY;


    const now = getCurrentKSTDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();


    // 한국 자산
    if (cat === KOREA) {
        const koresRes = await fetch(`/api/delayedMarketdt?iso=KR`);
        const { open_time, close_time } = await koresRes.json();
        let koreaOpenTimeHour = 9, koreaOpenTimeMinute = 5, koreaCloseTimeHour = 15, koreaCloseTimeMinute = 30;
        if (open_time) {
            koreaOpenTimeHour = Number(open_time.split(':')[0]) + 9
            koreaOpenTimeMinute = Number(open_time.split(':')[1]);
        }
        if (close_time) {
            koreaCloseTimeHour = Number(close_time.split(':')[0]) + 9
            koreaCloseTimeMinute = Number(close_time.split(':')[1]);
        }
        if (isHoliday) return close;
        if (hours >= koreaOpenTimeHour && (hours < koreaCloseTimeHour || (hours === koreaCloseTimeHour && minutes <= koreaCloseTimeMinute))) {
            return fiveMinDelay;
        }
        else return close;
    }

    // 미국 자산
    if (cat === US) {

        const IS_US_PRE_MARKET_TIME = detailData?.IS_US_PRE_MARKET_TIME || false;
        const IS_US_AFTER_MARKET_TIME = detailData?.IS_US_AFTER_MARKET_TIME || false;
        const IS_US_STANDARD_ORDER_TIME =
            detailData?.IS_US_STANDARD_ORDER_TIME || false;


        if ((IS_US_STANDARD_ORDER_TIME) && !isHoliday) {
            return fiveMinDelay;
        }
        else if (IS_US_AFTER_MARKET_TIME && !isHoliday) {
            return afterMarketFinMinDelay;
        }
        else {
            return nothing;
        }

    }

    //가상자산
    if (cat === CRYPTO) return fiveMinDelay;

    //그외
    return nothing;
}

export default priceUpdateStatus;